export default __webpack_public_path__ + "img/31.db06bf.png";